module.exports = __webpack_public_path__ + "static/media/refund.a4d8cb53.svg";